<form (submit)="editPerson()">
  <div class="container-large"
    [ngClass]="{'upload': form.value.rights === 'Upload', 'download': form.value.rights === 'Download'}">
    <div class="row">

      @if(form.value.rights === 'Upload') {
      <div class="col-md-12">
        <header class="screen-header upload fade-in">

          <div class="back">
            <a routerLink="/person-view" class="text-decoration-none">
              <i class="far fa-chevron-left"></i> {{ 'back' | translate }}
            </a>
          </div>

          <div class="content">
            <span class="icon-image">
              <img src="/public/images/upload-icon-color.svg" />
            </span>
            <div class="button-text">
              <h1 class="m-0"> {{'personEdit.title' | translate }} <strong class="text-higlight text-gradient">{{'upload' |
                  translate }}</strong> {{'personEdit.from' | translate }} <strong class="text-higlight text-gradient">{{form.controls.firstName.value}} {{form.controls.lastName.value}}</strong></h1>
            </div>
          </div>
        </header>
      </div>
      } @else if(form.value.rights === 'Download') {
      <div class="col-md-12">
        <header class="screen-header download fade-in">
          <div class="back">
            <a routerLink="/person-view" class="text-decoration-none">
              <i class="far fa-chevron-left"></i> {{ 'back' | translate }} 
            </a>
          </div>
          <div class="content">
            <span class="icon-image">
              <img src="/public/images/download-icon-color.svg" />
            </span>
            <div class="button-text">
              <h1 class="m-0">{{'personEdit.title' | translate }} <strong class="text-higlight text-gradient download">{{'download' | translate }}</strong> {{'personEdit.with' | translate }}  <strong class="text-higlight text-gradient">{{form.controls.firstName.value}} {{form.controls.lastName.value}}</strong></h1>
            </div>
          </div>
        </header>
      </div>
      }
    </div>
      <div class="row">
        <div class="col-md-12">
          <mat-card class="fade-up mb-3">
            <mat-card-header class="pb-0">
              <mat-card-title>{{'status-request' | translate }}</mat-card-title>
            </mat-card-header>

            <mat-card-content style="position: relative;" class="col-md-12">
              <ul class="timeline" id="timeline">
                <li class="li" [ngClass]="{'complete': statusDates.createdAt != null}">
                  <div class="status">
                    <h4>{{'status.Created' | translate }}</h4>
                    @if(statusDates.createdAt) {
                    <small>{{ statusDatesLocal.createdAt | date:'mediumDate' }} {{statusDatesLocal.createdAt | date:'shortTime' }}
                    </small>
                    } @else {
                    <small>-</small>
                    }
                  </div>
                </li>
                <li class="li" [ngClass]="{'complete': statusDates.sentAt != null}">
                  <div class="status">
                    <h4>{{'status.Sent' | translate }}</h4>
                    @if(statusDatesLocal.sentAt) {
                    <small>{{ statusDatesLocal.sentAt | date:'mediumDate' }} {{statusDatesLocal.sentAt | date:'shortTime' }}
                    </small>
                    } @else {
                    <small>-</small>
                    }
                  </div>
                </li>
                <li class="li" [ngClass]="{'complete': statusDates.loggedIn != null}">
                  <div class="status">
                    <h4>{{'status.LoggedIn' | translate }}</h4>
                    @if(statusDatesLocal.loggedIn) {
                    <small>{{ statusDatesLocal.loggedIn | date:'mediumDate' }} {{statusDatesLocal.loggedIn | date:'shortTime' }}
                    </small>
                    } @else {
                    <small>-</small>
                    }
                  </div>
                </li>
                @if(form.value.rights === 'Download') {
                <li class="li" [ngClass]="{'complete': statusDates.downloadedAt != null}">
                  <div class="status">
                    <h4>{{'status.FileDownloaded' | translate }}</h4>
                    @if(statusDatesLocal.downloadedAt) {
                    <small>{{ statusDatesLocal.downloadedAt | date:'mediumDate' }} {{statusDatesLocal.downloadedAt | date:'shortTime' }}
                    </small>
                    } @else {
                    <small>-</small>
                    }
                  </div>
                </li>
                }
                @else {
                <li class="li" [ngClass]="{'complete': statusDates.uploadedAt != null}">
                  <div class="status">
                    <h4>{{'status.FileUploaded' | translate }}</h4>
                    @if(statusDatesLocal.uploadedAt) {
                    <small>{{ statusDatesLocal.uploadedAt | date:'mediumDate' }} {{statusDatesLocal.uploadedAt | date:'shortTime' }}
                    </small>
                    } @else {
                    <small>-</small>
                    }
                  </div>
                </li>
                }
              </ul>
            </mat-card-content>
          </mat-card>
        </div>
        
        <div class="col-md-7">
          <mat-card class="fade-up mb-2" style="height:100%">
            <mat-card-header class="col-md-12">
              <mat-card-title>{{ 'sharePointBlock-edit.title' | translate }}</mat-card-title>
              <mat-card-subtitle>{{ 'sharePointBlock-edit.subText' | translate }}</mat-card-subtitle>
            </mat-card-header>

          <mat-card-content style="position: relative;" class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'sharePointBlock.site' | translate }}
                @if (loadingSites) {
                <mat-spinner [diameter]="15" class="inline"></mat-spinner>
                }
              </mat-label>
              <mat-select [formControl]="form.controls.siteId">
                @for (site of sites; track site) {
                <mat-option [class.selected-site]="site.siteId === form.value.siteId" [value]="site.siteId">
                  {{site.displayName}}
                </mat-option>
                }
              </mat-select>
              @if (form.controls.siteId.errors?.['required']) {
              <mat-error>{{ 'error.site' | translate }}</mat-error>
              }
            </mat-form-field>

              @if (loadingSite) {
              <div class="spinner-wrapper">
                <mat-spinner></mat-spinner>
                <span class="spinner-label">{{ 'map-loading' | translate }}</span>
              </div>
              } @else {
              @if (form.value.siteId) {
                <app-folder-tree [siteId]="form.value.siteId" [folders]="(folders$ | async) ?? []"
                  [selectedFolder]="selectedFolder"
                  [loadingMore]="loadingMoreFolders"
                  [hasMoreFolders]="hasMoreFolders"
                  (folderEvent)="onFolderSelected($event)"
                  (loadMoreRequested)="onLoadMoreFolders()"
                  (createFolderRequested)="onCreateFolderRequested($event)">
                </app-folder-tree>
                }
              }
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col-md-5">

          <mat-card class="fade-up delay-1 card-horizontal">
            <mat-card-header>
              <mat-card-title>{{ 'personEdit.personBlock.title' | translate }}</mat-card-title>
              <mat-card-subtitle>{{ 'personEdit.personBlock.subText' | translate }}</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              @if (loading) {
              <div class="spinner-wrapper">
                <mat-spinner></mat-spinner>
                <span class="spinner-label">{{ 'map-loading' | translate }}</span>
              </div>
              } @else {
              <mat-form-field appearance="outline">
                <mat-label>{{ 'firstName' | translate }}</mat-label>
                <input matInput [formControl]="form.controls.firstName" [placeholder]="'firstName' | translate" />
                @if (form.controls.firstName.errors?.['required']) {
                <mat-error>{{ 'error.firstName' | translate }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'lastName' | translate }}</mat-label>
                <input matInput [formControl]="form.controls.lastName" [placeholder]="'lastName' | translate" />
                @if (form.controls.lastName.errors?.['required']) {
                <mat-error>{{ 'error.lastName' | translate }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'email' | translate }}</mat-label>
                <input matInput [formControl]="form.controls.email" [placeholder]="'email' | translate" />
                @if (form.controls.email.errors?.['required']) {
                <mat-error>{{ 'error.emailRequired' | translate }}</mat-error>
                }
                @if (form.controls.email.errors?.['pattern']) {
                <mat-error>{{ 'error.emailInvalid' | translate }}</mat-error>
                }
              </mat-form-field>

              <div class="row">
                <div class="col-md-6">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'language' | translate }}</mat-label>
                    <mat-select [formControl]="form.controls.language">
                      <mat-option value="Dutch">{{ 'dutch' | translate }}</mat-option>
                      <mat-option value="English">{{ 'english' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'personCreate.personBlock.tokenEndDate' | translate }}</mat-label>
                    <mat-select [formControl]="form.controls.endDateType">
                      <mat-option value="1">1 dag</mat-option>
                      <mat-option value="7">7 dagen (default)</mat-option>
                      <mat-option value="14">14 dagen</mat-option>
                      <mat-option value="30">30 dagen</mat-option>
                      <mat-option value="90">90 dagen</mat-option>
                      <mat-option value="180">180 dagen</mat-option>
                      <mat-option value="custom">Custom</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              @if (form.value.endDateType ==='custom') {
              <mat-form-field appearance="outline">
                <mat-label>{{ 'personCreate.personBlock.tokenEndDate' | translate }}</mat-label>
                <input matInput [min]="minDate" [max]="maxDate" [formControl]="form.controls.endDate"
                  [matDatepicker]="picker" [placeholder]="'personCreate.personBlock.tokenEndDate' | translate" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              }

              <!-- <mat-radio-group [formControl]="form.controls.rights">
              @for (item of PersonRightsTypes; track item) {
              <mat-radio-button [value]="item.value">{{ item.text | translate}}</mat-radio-button>
              }
              </mat-radio-group>
              @if (form.controls.rights.errors?.['invalidRight']) {
              <mat-error>{{ 'error.rights' | translate }}</mat-error>
              } -->

              }

              <strong class="pb-1">{{ 'personCreate.messageBlock.title' | translate }}</strong>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'personCreate.messageBlock.label' | translate }}</mat-label>
                <textarea matInput [formControl]="form.controls.message"
                  [placeholder]="'personCreate.messageBlock.subText' | translate"></textarea>
              </mat-form-field>
              <br />

              <div style="display:flex;justify-content:space-between;gap:16px">
                &nbsp;

                <!--
                <button mat-stroked-button type="button" routerLink="/person-view">
                  {{ 'cancel' | translate }}
                </button>-->

                <div style="display: flex;gap:16px">
                  <!-- <button mat-stroked-button class="btn-lg" type="submit" [disabled]="preventSubmit">
                  {{ 'personEdit.save' | translate }}
                  </button> -->
                  <button mat-flat-button class="btn-lg" type="submit" color="primary"
                    [disabled]="disableTokenButton || preventSubmit">
                    <i class="fa-light fa-paper-plane-top"></i>&nbsp; {{ 'personEdit.sendInvite' | translate }}
                  </button>
                </div>
              </div>

            </mat-card-content>
          </mat-card>
        
        </div>
      </div>
    </div>

</form>